// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"d5-z","colorTextValue":"e5-z","swatches":"f5-z","collapseLink":"g5-z","isCollapsed":"h5-z","dropdown":"i5-z","disabled":"j5-z"};